import { doLogout } from "actions/authAction";

import {
  BASE_URL,
  PURCHASE_URL,
  PURCHASE_GET_ERROR,
  PURCHASE_GET_LOADING,
  PURCHASE_GET_SUCCESS,
  PURCHASE_VIEW_ERROR,
  PURCHASE_VIEW_LOADING,
  PURCHASE_VIEW_SUCCESS,
  PURCHASE_ADD_ERROR,
  PURCHASE_ADD_LOADING,
  PURCHASE_ADD_SUCCESS,
  PURCHASE_DELETE_ERROR,
  PURCHASE_DELETE_LOADING,
  PURCHASE_DELETE_SUCCESS,
  PURCHASE_CANCEL,
  PURCHASE_UPDATE_URL,
} from "./constant";
import { error } from "jquery";

const purchaseGetError = (bool) => {
  return {
    type: PURCHASE_GET_ERROR,
    purchaseGetError: bool,
  };
};

const purchaseGetLoading = (bool) => {
  return {
    type: PURCHASE_GET_LOADING,
    purchaseGetLoading: bool,
  };
};

const purchaseGetSuccess = (bool, purchases) => {
  return {
    type: PURCHASE_GET_SUCCESS,
    purchaseGetSuccess: bool,
    purchases,
  };
};

const purchaseViewError = (bool) => {
  return {
    type: PURCHASE_VIEW_ERROR,
    purchaseViewError: bool,
  };
};

const purchaseViewLoading = (bool) => {
  return {
    type: PURCHASE_VIEW_LOADING,
    purchaseViewLoading: bool,
  };
};

const purchaseViewSuccess = (bool, purchase) => {
  return {
    type: PURCHASE_VIEW_SUCCESS,
    purchaseViewSuccess: bool,
    purchase,
  };
};

const purchaseAddError = (bool) => {
  return {
    type: PURCHASE_ADD_ERROR,
    purchaseAddError: bool,
  };
};

const purchaseAddLoading = (bool) => {
  return {
    type: PURCHASE_ADD_LOADING,
    purchaseAddLoading: bool,
  };
};

const purchaseAddSuccess = (bool, purchase) => {
  return {
    type: PURCHASE_ADD_SUCCESS,
    purchaseAddSuccess: bool,
    purchase,
  };
};

const purchaseDeleteError = (bool) => {
  return {
    type: PURCHASE_DELETE_ERROR,
    purchaseDeleteError: bool,
  };
};

const purchaseDeleteLoading = (bool) => {
  return {
    type: PURCHASE_DELETE_LOADING,
    purchaseDeleteLoading: bool,
  };
};

const purchaseDeleteSuccess = (bool, purchase) => {
  return {
    type: PURCHASE_DELETE_SUCCESS,
    purchaseDeleteSuccess: bool,
    purchase,
  };
};

const purchaseUpdateDimensiTonaseSuccess = (bool, val) => {
  return {
    type: "purchaseUpdateDimensiTonaseSuccess",
    bolean: bool,
    val,
  };
};

const purchasePriceApprove_by_consigneeSuccess = (bool, val) => {
  return {
    type: "PriceApprove_by_consignee",
    purchaseAddSuccess: bool,
    val,
  };
};

const purchaseCancel = (bool, cancel) => {
  return {
    type: PURCHASE_CANCEL,
    purchaseCancelSuccess: bool,
    cancel,
  };
};

export function purchasePriceApprove_by_consignee(data) {
  return (dispatch) => {
    dispatch(purchasePriceApprove_by_consigneeSuccess(true, 0));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "purchaseorder/approve_by_consignee", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(purchasePriceApprove_by_consigneeSuccess(false, 1));
        } else {
          window.alert(value.message);
          dispatch(purchasePriceApprove_by_consigneeSuccess(false, 0));
        }
      })
      .catch((err) => {
        window.alert(err);
        dispatch(purchasePriceApprove_by_consigneeSuccess(false, 0));
      });
  };
}

export function purchaseUpdateDimensiTonase(data) {
  return (dispatch) => {
    dispatch(purchaseUpdateDimensiTonaseSuccess(true, 0));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "put",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "purchaseorder/dimensi_tonase", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(purchaseUpdateDimensiTonaseSuccess(false, 1));
        } else {
          window.alert(data.message);
          dispatch(purchaseUpdateDimensiTonaseSuccess(false, 0));
        }
      })
      .catch((err) => {
        window.alert(err);
        dispatch(purchaseUpdateDimensiTonaseSuccess(false, 0));
      });
  };
}

export function purchaseFetchAll() {
  return (dispatch) => {
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseGetSuccess(false, null));
    dispatch(purchaseGetError(false));
    dispatch(purchaseGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + PURCHASE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(purchaseGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(purchaseGetError(true));
      });
  };
}

export function purchaseFetchSub(path) {
  return (dispatch) => {
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseGetSuccess(false, null));
    dispatch(purchaseGetError(false));
    dispatch(purchaseGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL + "/" + path, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(purchaseGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(purchaseGetError(true));
      });
  };
}

export function purchaseFetchBooking(param) {
  return (dispatch) => {
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseGetSuccess(false, null));
    dispatch(purchaseGetError(false));
    dispatch(purchaseGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(param),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL + "/booking", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(purchaseGetSuccess(true, data));
        dispatch(purchaseGetLoading(false));
      })
      .catch((err) => {
        dispatch(purchaseGetError(true));
        dispatch(purchaseGetLoading(false));
      });
  };
}

export function purchaseFetchPage(param) {
  return (dispatch) => {
    dispatch(purchaseGetSuccess(false, null));
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseGetError(false));
    dispatch(purchaseGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(param),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL + "/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(purchaseGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(purchaseGetError(true));
      });
  };
}

const PURCHASE_SET_BIAYA = "PURCHASE_SET_BIAYA";

const purchaseSetBiayaLoading = (bool) => {
  return {
    type: PURCHASE_SET_BIAYA + "_LOADING",
    loading: bool,
  };
};

const purchaseSetBiayaError = (bool) => {
  return {
    type: PURCHASE_SET_BIAYA + "_ERROR",
    error: bool,
  };
};

const purchaseSetBiayaSuccess = (bool) => {
  return {
    type: PURCHASE_SET_BIAYA + "_SUCCESS",
    success: bool,
  };
};

export function purchaseSetBiaya(data) {
  return (dispatch) => {
    dispatch(purchaseSetBiayaLoading(true));
    dispatch(purchaseSetBiayaError(false));
    dispatch(purchaseSetBiayaSuccess(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "purchaseorder/set_biaya_pengiriman", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseSetBiayaLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((purchase) => {
        // dispatch(purchaseSetBiayaSuccess(true, purchase));
        dispatch(purchaseSetBiayaSuccess(true));
      })
      .catch((err) => {
        dispatch(purchaseSetBiayaError(true));
      });
  };
}

export function purchaseAdd(data) {
  return (dispatch) => {
    dispatch(purchaseAddError(false));
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    // let formData = new FormData();
    // for (var key in data) {
    //   formData.append(key, data[key]);
    // }

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((purchase) => {
        if (purchase.success) {
          dispatch(purchaseAddSuccess(true, purchase));
        } else {
          dispatch(purchaseAddError(true));
        }
      })
      .catch((err) => {
        dispatch(purchaseAddError(true));
      });
  };
}

export function purchaseUpdate(data) {
  return (dispatch) => {
    dispatch(purchaseAddError(false));
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          // "Content-Type": "application/json",
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_UPDATE_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((purchase) => {
        if (purchase.status === 200) {
          dispatch(purchaseAddSuccess(true, purchase));
        } else {
          dispatch(purchaseAddError(true));
        }
      })
      .catch((err) => {
        dispatch(purchaseAddError(true));
      });
  };
}

export function purchaseSupplierApproval(data) {
  return (dispatch) => {
    dispatch(purchaseAddError(false));
    dispatch(purchaseViewSuccess(false, null));
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + PURCHASE_URL + "/approve", config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((purchase) => {
        if (purchase.status == 200) {
          dispatch(purchaseAddSuccess(true, purchase));
        } else {
          dispatch(purchaseAddError(true));
        }
      })
      .catch((err) => {
        dispatch(purchaseAddError(true));
      });
  };
}

export function purchaseSetFcl(data) {
  return (dispatch) => {
    dispatch(purchaseAddError(false));
    dispatch(purchaseViewSuccess(false, null));
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL + "/set_fcl", config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((purchase) => {
        if (purchase.status == 200) {
          dispatch(purchaseAddSuccess(true, purchase));
        } else {
          dispatch(purchaseAddError(true));
        }
      })
      .catch((err) => {
        dispatch(purchaseAddError(true));
      });
  };
}

export function purchaseShipperApproval(data) {
  return (dispatch) => {
    dispatch(purchaseAddError(false));
    dispatch(purchaseViewSuccess(false, null));
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL + "/approve_by_shipper", config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((purchase) => {
        if (purchase.status == 200) {
          dispatch(purchaseAddSuccess(true, purchase));
        } else {
          dispatch(purchaseAddError(true));
        }
      })
      .catch((err) => {
        dispatch(purchaseAddError(true));
      });
  };
}

export function purchaseFetchOne(id) {
  return (dispatch) => {
    dispatch(purchaseAddSuccess(false, null));
    dispatch(purchaseViewError(false));
    dispatch(purchaseViewSuccess(false, null));
    dispatch(purchaseViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL + "/" + id, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(purchaseViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(purchaseViewError(true));
      });
  };
}

export function purchaseDelete(id) {
  return (dispatch) => {
    dispatch(purchaseViewSuccess(false, null));
    dispatch(purchaseDeleteError(false));
    dispatch(purchaseDeleteSuccess(false, null));
    dispatch(purchaseDeleteLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: id }),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + PURCHASE_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseDeleteLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(purchaseDeleteSuccess(true, data));
      })
      .catch((err) => {
        dispatch(purchaseDeleteError(true));
      });
  };
}

export function purchase_cancel(data) {
  return (dispatch) => {
    dispatch(purchaseCancel(false, 0));
    dispatch(purchaseGetError(false));
    dispatch(purchaseGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "purchaseorder/cancel-po", config, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(purchaseGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(purchaseCancel(true, data));
      })
      .catch((err) => {
        dispatch(purchaseGetError(true));
      });
  };
}

export const LIST_PORT_URL = "pelabuhan";
export const LIST_PORT_GET_LOADING = "LIST_PORT_GET_LOADING";
export const LIST_PORT_GET_SUCCESS = "LIST_PORT_GET_SUCCESS";
export const LIST_PORT_GET_ERROR = "LIST_PORT_GET_ERROR";

const getListPortLoading = (bool) => {
  return {
    type: LIST_PORT_GET_LOADING,
    getListPortLoading: bool,
  };
};

const getListPortSuccess = (bool, port) => {
  return {
    type: LIST_PORT_GET_SUCCESS,
    getListPortSuccess: bool,
    port,
  };
};

const getListPortError = (bool) => {
  return {
    type: LIST_PORT_GET_ERROR,
    getListPortError: bool,
  };
};

export function getListPort() {
  return (dispatch) => {
    dispatch(getListPortLoading(true));
    dispatch(getListPortSuccess(false, null));
    dispatch(getListPortError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + LIST_PORT_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(getListPortSuccess(true, data));
        dispatch(getListPortLoading(false));
      })
      .catch((err) => {
        dispatch(getListPortError(true));
      });
  };
}

export const LIST_JENIS_USER_CONSIGNE_URL = "list_jenis_consignee_berangkat";
export const LIST_JENIS_USER_CONSIGNE_GET_LOADING =
  "LIST_JENIS_USER_CONSIGNE_GET_LOADING";
export const LIST_JENIS_USER_CONSIGNE_GET_SUCCESS =
  "LIST_JENIS_USER_CONSIGNE_GET_SUCCESS";
export const LIST_JENIS_USER_CONSIGNE_GET_ERROR =
  "LIST_JENIS_USER_CONSIGNE_GET_ERROR";

const getJenisUserConsigneLoading = (bool) => {
  return {
    type: LIST_JENIS_USER_CONSIGNE_GET_LOADING,
    getJenisUserConsigneLoading: bool,
  };
};

const getJenisUserConsigneSuccess = (bool, jenisUserConsigne) => {
  return {
    type: LIST_JENIS_USER_CONSIGNE_GET_SUCCESS,
    getJenisUserConsigneSuccess: bool,
    jenisUserConsigne,
  };
};

const getJenisUserConsigneError = (bool) => {
  return {
    type: LIST_JENIS_USER_CONSIGNE_GET_ERROR,
    getJenisUserConsigneError: bool,
  };
};

export function getJenisUserConsigne() {
  return (dispatch) => {
    dispatch(getJenisUserConsigneLoading(true));
    dispatch(getJenisUserConsigneSuccess(false, null));
    dispatch(getJenisUserConsigneError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + LIST_JENIS_USER_CONSIGNE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(getJenisUserConsigneSuccess(true, data));
        dispatch(getJenisUserConsigneLoading(false));
      })
      .catch((err) => {
        dispatch(getJenisUserConsigneError(true));
      });
  };
}
